// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"f06b9898","70":"131c46ab","219":"e6d287af","844":"34f9b3dc","848":"d0c447bd"}[chunkId] + ".chunk.css";
};